import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormCafeteriaItemComponent from '../components/FormCafeteriaItemComponent';
import CafeteriaRecipeComponent from '../components/CafeteriaRecipeComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class EditCafeteriaMenuPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false, initial: null, code: null };
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const code = params.get('code');
        this.setState({ checked: true, role, code });
        this.fetchData(code);
    }

    fetchData = (code) => {
        const request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `cafeteria/menu/${encodeURIComponent(code)}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error === 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    this.setState({ initial: data.data });
                }
            });
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        const request = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
            body: JSON.stringify(value),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `cafeteria/menu/${encodeURIComponent(this.state.code)}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ disabled: false });
                } else {
                    navigateTo('/cafeteriaMenu');
                }
            });
    }

    // ENI-90: estado de vendibilidad del ítem (sin control / no vendible / disponible).
    renderStatus() {
        const it = this.state.initial;
        if (!it) {
            return null;
        }
        if (Number(it.isRecipeBased) === 0) {
            return (<div className="alert alert-secondary py-2">Sin control de stock: siempre disponible.</div>);
        }
        if (it.sellable === false) {
            return (<div className="alert alert-warning py-2">No vendible: falta cargar la receta (agregá al menos un insumo abajo).</div>);
        }
        return (<div className="alert alert-info py-2">Consumible por receta · disponible: {it.available != null ? it.available : '—'}.</div>);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={26} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Cafetería" subtitle="Editar ítem de menú" />
                            {this.state.initial != null ? (
                                <React.Fragment>
                                    {this.renderStatus()}
                                    <FormCafeteriaItemComponent
                                        editMode
                                        initial={this.state.initial}
                                        onChangeData={this.handleChangeData}
                                        disabled={this.state.disabled}
                                        role={this.state.role}
                                    />
                                    <CafeteriaRecipeComponent gastronomyCode={this.state.code} />
                                </React.Fragment>
                            ) : (
                                <div className="card card-small mb-4"><div className="card-body p-4">Cargando…</div></div>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditCafeteriaMenuPage;
